import { useTranslation } from 'react-i18next';
import logo from '@/assets/marca/logo-batech-retallat.png';

/**
 * Logotip oficial BAtech (quadrat blau marí amb el triangle d'avís i el nom «BAtech.»).
 * Imatge oficial retallada de `logo-batech.png`; mai no es redibuixa en codi.
 */
export function Logotip({ mida = 36, className }: { mida?: number; className?: string }) {
  const { t } = useTranslation('comu');
  return (
    <img
      className={className}
      src={logo}
      alt={t('app.logoAlt')}
      height={mida}
      style={{ height: mida, width: 'auto' }}
      draggable={false}
    />
  );
}
